/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, memo } from "react";
import {
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Spinner,
  Label,
  FormGroup,
} from "reactstrap";

import { useForm } from "react-hook-form";
import schema from "./schema";

import toastr from "toastr";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";

import { useSelector, useDispatch } from "react-redux";
import {
  getSkillsAttendance,
  createAttendance,
} from "../../../../store/operator/actions";

const CloseChat = ({ t, toggle, isOpen }) => {
  const dispatch = useDispatch();

  const { data, status } = useSelector(
    (state) => state.Operator.createAttendance
  );

  const { register, handleSubmit, errors, setValue, getValues } = useForm({
    resolver: yupResolver(schema),
  });

  const [attendanceValues, setAttendanceValues] = useState({
    name: "",
    cpf: "",
    skill: null,
  });

  const skillsOptions = useMemo(() => {
    return (
      data.skills?.map((skill) => {
        return {
          value: skill.id,
          label: skill.name,
        };
      }) || []
    );
  }, [data?.skills]);

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  const activeSpinner = useMemo(() => {
    return (
      status?.get_skills_attendance?.loading ||
      status?.create_attendance?.loading
    );
  }, [
    status?.get_skills_attendance?.loading,
    status?.create_attendance?.loading,
  ]);

  const setClassName = (errorsForm) => {
    return errorsForm ? "av-invalid is-invalid form-control" : "form-control";
  };

  const cpfMask = (value) => {
    return value
      ?.replace(/\D/g, "")
      ?.replace(/(\d{3})(\d)/, "$1.$2")
      ?.replace(/(\d{3})(\d)/, "$1.$2")
      ?.replace(/(\d{3})(\d{1,2})/, "$1-$2")
      ?.replace(/(-\d{2})\d+?$/, "$1");
  };

  const onSubmit = (dataForm) => {
    dispatch(createAttendance({ ...dataForm, cpf: dataForm.cpf.replace(/\D/g, "") }));
  };

  useEffect(() => {
    setValue("name", attendanceValues.name);
    setValue("cpf", attendanceValues.cpf);
    setValue("skill", attendanceValues.skill, {
      shouldValidate: true,
    });
  }, [attendanceValues]);

  useEffect(() => {
    if (!isOpen) return;
    if (status?.get_skills_attendance?.success) return;

    dispatch(getSkillsAttendance());
  }, [dispatch, isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    if (status?.create_attendance?.success) {
      showToast("success", t("Attendance created successfully"));
      setAttendanceValues({
        name: "",
        cpf: "",
        skill: null,
      });
      toggle();
    }

    if (status?.create_attendance?.error) {
      showToast("error", t("Error creating attendance"));
    }
  }, [status?.create_attendance]);

  useEffect(() => {
    if (!isOpen) return;

    if (status?.get_skills_attendance?.error) {
      showToast("error", t("Error getting skills"));
    }
  }, [status?.get_skills_attendance]);

  useEffect(() => {
    if (!isOpen) return;

    if (skillsOptions.length === 1) {
      setAttendanceValues((prev) => ({
        ...prev,
        skill: skillsOptions[0]?.value,
      }));
    }
  }, [skillsOptions, isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen || status?.create_attendance?.loading}
        toggle={toggle}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader className="modal-header-no-button" toggle={toggle}>
            {t("Create new attendance")}
          </ModalHeader>
          <ModalBody>
            <FormGroup className="select2-container">
              <Label id="name">{t("Name")}</Label>
              <input
                type="text"
                name="name"
                ref={register}
                className={setClassName(errors.name)}
                placeholder={t("Enter name")}
                onChange={(e) => {
                  const value = e.target.value;
                  setAttendanceValues((prev) => ({
                    ...prev,
                    name: value,
                  }));
                }}
                defaultValue={attendanceValues.name}
              />
              <div className="invalid-feedback d-block">
                {t(errors.name?.message)}
              </div>
            </FormGroup>
            <FormGroup className="select2-container">
              <Label id="cpf">{t("CPF")}</Label>
              <input
                type="text"
                name="cpf"
                ref={register}
                className={setClassName(errors.cpf)}
                placeholder={t("Enter CPF")}
                onChange={(e) => {
                  const value = cpfMask(e.target.value);

                  setAttendanceValues((prev) => ({
                    ...prev,
                    cpf: value,
                  }));
                }}
                defaultValue={attendanceValues.cpf}
                autoComplete="off"
              />
              <div className="invalid-feedback d-block">
                {t(errors.cpf?.message)}
              </div>
            </FormGroup>
            <FormGroup className="select2-container">
              <Label id="skill">{t("Skill")}</Label>
              <Select
                id="skill"
                name="skill"
                ref={() => register({ name: "skill" })}
                classNamePrefix="select2-selection"
                placeholder={t("Choose") + "..."}
                options={skillsOptions}
                value={skillsOptions.find(
                  (option) => option.value === getValues().skill
                )}
                onChange={(e) => {
                  const value = e?.value;
                  setAttendanceValues((prev) => ({
                    ...prev,
                    skill: value,
                  }));
                }}
              />
              <div className="invalid-feedback d-block">
                {t(errors.skill?.message)}
              </div>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              onClick={toggle}
              className={`btn btn-dark ${
                status?.create_attendance?.loading ? "isDisabled" : ""
              }`}
              disabled={status?.create_attendance?.loading}
            >
              {t("Cancel")}
            </button>

            <button
              type="submit"
              color="primary"
              className={`btn btn-primary ${activeSpinner ? "isDisabled" : ""}`}
              disabled={activeSpinner || status?.get_skills_attendance?.error}
            >
              {activeSpinner ? <Spinner size="sm" /> : t("Create Attendance")}
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
};
export default withTranslation()(memo(CloseChat));
